import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { ChartConfigBase } from '../../models/chart-config-base';
import { HighChartDataBase } from '../../models/high-chart-data-base';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'chart-total-sum',
    styleUrls: ['./chart-total-sum.scss'],
    template: `
        @if (chartData && chartData.showTotal===true) {
          <div class='ms-lg-5'>
            <p class="chart-total-sum text-muted mb-0">{{ 'xml-report.chart.sum' | translate }}: {{seriesTotal}} {{chartData.displayUnit}}</p>
          </div>
        }
        `,
    host: { 'cid': 'chartsum' },
    imports: [TranslatePipe]
})
export class ChartTotalSumComponent {
    @Input() chartData: HighChartDataBase;

    seriesTotal: string;

    constructor(
        private translate: TranslateService
    ) { }

    ngOnInit() {
    	this.seriesTotal = new Intl.NumberFormat(this.translate.currentLang).format(this.chartData.seriesTotal);
    }
}
